import { useEffect , useContext} from 'react';
import {apiService} from '../../helpers/api';
import apiCall from './../../helpers/apifactory';
import {ServicesProvider} from './../common/AlertService';


const Dashboard = (props)=>{
    const {alertMessage, loaderShow} = useContext(ServicesProvider)

    useEffect(() => {
        // loaderShow();
        setTimeout(() => {
            // loaderShow(false);
        }, 5000);
        console.log(alertMessage());
        alertMessage('heello', 'error');
    }, [])
    
    return(
        <div>
            Dashboard content
            
        </div>
    )
}

export default Dashboard;